import { isSegmentsByLanguageLoaded, segmentsByLanguage } from '../world/segmentsByLanguage';
import { segmentsForExtinct } from '../world/segmentsForExtinct';
import { segmentsForMisc } from '../world/segmentsForMisc';
import { TrackLanguageFeatures } from '../world/trackLanguageFeatures';
import { ipaCombos, ipaSingles } from './chart/ChartSymbols';

/** get an object that tracks information about phonemes for a wide variety of languages */
export function getLanguageTrackers(): TrackLanguageFeatures {
  if (languageTrackers) {
    return languageTrackers;
  }

  const lt = new TrackLanguageFeatures();
  lt.add(segmentsByLanguage);
  lt.add(segmentsForExtinct, 'extinct');
  lt.add(segmentsForMisc);
  lt.compute(ipaSingles.concat(ipaCombos));
  if (isSegmentsByLanguageLoaded) {
    // only store if segmentsByLanguage has been loaded
    languageTrackers = lt;
  }
  return lt;
}

let languageTrackers: TrackLanguageFeatures | undefined = undefined;
